import type { SVGProps } from "react";
import * as React from "react";

const SvgGitMerge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 21a1 1 0 1 0 2 0zm15-3a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zm-2 2a2 2 0 0 1-2-2h-2a4 4 0 0 0 4 4zm-2-2a2 2 0 0 1 2-2v-2a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zM8 6a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zM6 8a2 2 0 0 1-2-2H2a4 4 0 0 0 4 4zM4 6a2 2 0 0 1 2-2V2a4 4 0 0 0-4 4zm2-2a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zm1 17V9H5v12zM5 9a10 10 0 0 0 2.929 7.071l1.414-1.414A8 8 0 0 1 7 9zm2.929 7.071A10 10 0 0 0 15 19v-2a8 8 0 0 1-5.657-2.343z"
    />
  </svg>
);
export default SvgGitMerge;
